// Script mínimo para funcionalidades críticas
(function () {
  "use strict";

  // Funcionalidades críticas que não podem esperar
  window.criticalFunctions = {
    openCart: function () {
      // Função básica para abrir carrinho
      const cart = document.querySelector("#halo-cart-sidebar");
      if (cart) cart.classList.add("is-visible");
    },

    addToCart: function (variantId, quantity) {
      // Função básica de adicionar ao carrinho
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: quantity }),
      })
        .then((response) => response.json())
        .then(() => this.openCart());
    },
  };

  // Disponibilizar globalmente
  window.openSideCart = window.criticalFunctions.openCart;
})();
